import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Stepper, Step } from "react-form-stepper";
import { MdDescription } from "react-icons/md";
import StepWizard from "react-step-wizard";
import { Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import FileBase64 from "react-file-base64";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
// import StepOne from "./StepOne";
import textimage from "../../../../../images/foods/textimage.png";
import multmedi from "../../../../../images/foods/multmedi.png";
import textandmulti from "../../../../../images/foods/textandmulti.png";
import texticon from "../../../../../images/foods/texticon.png";
import mediaicon from "../../../../../images/foods/media.png";
import audioalone from "../../../../../images/foods/audioalone.png";
import audiovideo from "../../../../../images/foods/audiovideo.png";
import template from "../../../../../images/foods/template.png";
import imagefile from "../../../../../images/foods/imagefile.png";
import individual from "../../../../../images/individual.png";
import multiple from "../../../../../images/multiple.png";
import {
  getCustomerMasterlist,
  saveCustomerDetails,
  updateCustomerDetails,
  broadcast_whatsapp_call,
  getApprovalTemplateListMaster,
} from "../../../../../apiservicescall/api";
import Select from "react-select";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TableRow, Tooltip, CloudDownloadOutlined } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";

const ActionButtons = (props) => {
  // console.log(
  //   "disabled_Checkasdfdsf 4444",
  //   // props,
  //   props
  // );
  const handleBack = () => {
    props.previousStep();
  };
  const isNextEnabled = () => {
    const isMessageTypeValid = ["1", "2", "3", "4", "5", "7"].includes(
      props.campaign_creation.selected_message_type
    );
  
    let isMandatoryFieldsFilled = false;
    switch (props.campaign_creation.selected_message_type) {
      case "1": 
        isMandatoryFieldsFilled = props.campaign_creation.selected_message_text !== "";
        break;
      case "2": 
        isMandatoryFieldsFilled = props.campaign_creation.selected_message_file !== "";
        break;
        case "3": 
        isMandatoryFieldsFilled = props.campaign_creation.selected_message_file !== ""; 
        break;
        case "4": 
        isMandatoryFieldsFilled = props.campaign_creation.selected_message_file !== "";
        break;
      case "5": 
        isMandatoryFieldsFilled =
          props.campaign_creation.selected_Latitude !== "" &&
          props.campaign_creation.selected_longitude !== "";
        break;
      case "7":
        isMandatoryFieldsFilled = !!props.campaign_creation.selected_template_name;
        break;
      default:
        isMandatoryFieldsFilled = true;
        break;
    }
  
    return isMessageTypeValid && isMandatoryFieldsFilled;
  };
  
  const handleNext = () => {
    props.nextStep();
  };

  const handleFinish = () => {
    props.lastStep();
  };

  const disabled_Check = () => {
    if (
      (props.campaign_creation.selected_message_type == "1" ||
        props.campaign_creation.selected_message_type == "2" ||
        props.campaign_creation.selected_message_type == "3" ||
        props.campaign_creation.selected_message_type == "4") &&
      props.campaign_creation.selected_message_text == ""
    ) {
      console.log(
        "disabled_Checkasdfdsf 1111",
        // props,
        props.campaign_creation
      );
      return true;
    } else if (
      (props.campaign_creation.selected_message_type == "2" ||
        props.campaign_creation.selected_message_type == "3" ||
        props.campaign_creation.selected_message_type == "4") &&
      (props.campaign_creation.selected_message_file == "" ||
        props.campaign_creation.selected_message_text == "")
    ) {
      console.log(
        "disabled_Checkasdfdsf 2222",
        // props,
        props.campaign_creation
      );
      return true;
    } else if (
      props.campaign_creation.selected_message_type == "5" &&
      (props.campaign_creation.selected_Latitude == "" ||
        props.campaign_creation.selected_longitude == "")
      // props.campaign_creation.selected_address == "" ||
      // props.campaign_creation.selected_address_name == ""
    ) {
      console.log(
        "disabled_Checkasdfdsf 3333",
        // props,
        props.campaign_creation
      );
      return true;
    } else if (
      props.campaign_creation.selected_message_type == "7" &&
      props.campaign_creation.selected_template_name == ""
    ) {
      console.log(
        "disabled_Checkasdfdsf 5555",
        // props,
        props.campaign_creation
      );
      return true;
    }
    // else {
    //   console.log(
    //     "disabled_Checkasdfdsf 4444",
    //     // props,
    //     props.campaign_creation
    //   );
    //   return false;
    // }
  };

  return (
    <div>
      <br />
      <br />
      <Row className="mt-0">
        <div className="col-6 brdcst-bck-btn">
          <Button
            size="medium"
            disabled={props.currentStep <= 1}
            onClick={handleBack}
          >
            Back
          </Button>
        </div>
        <div
          className="col-6 brdcst-nxt-btn"
          style={{ display: "flex", justifyContent: "end" }}
        >
          {/* {props.campaign_creation.selected_message_type != "5" &&
            props.campaign_creation.selected_message_type != "7" &&
            props.campaign_creation.selected_message_text != "" &&
            props.currentStep < props.totalSteps && (
              <Button
                variant="contained"
                style={{ marginLeft: "75%" }}
                size="medium"
                onClick={handleNext}
              >
                Next
              </Button>
            )} */}

          {props.currentStep < props.totalSteps && (
             <Button
             variant="contained"
             size="medium"
             disabled={props.currentStep > 1 && !isNextEnabled()} // Updated disabled condition
             onClick={handleNext}
           >
              Next
            </Button>
          )}

          {props.currentStep === props.totalSteps && (
            <div>
              <Button
                variant="contained"
                style={{
                  backgroundColor:
                    (props.campaign_creation.message_recipient_type === "1" &&
                      props.campaign_creation.message_recipient_no !== "") ||
                    (props.campaign_creation.message_recipient_type === "2" &&
                      props.campaign_creation.message_recipient_file !== "")
                      ? "greenyellow"
                      : "grey",
                  color: "black",
                }}
                size="medium"
                disabled={
                  (props.campaign_creation.message_recipient_type === "1" &&
                    props.campaign_creation.message_recipient_no === "") ||
                  (props.campaign_creation.message_recipient_type === "2" &&
                    props.campaign_creation.message_recipient_file === "")
                }
                onClick={() => {
                  handleFinish();
                  props.submit_campaign_creation();
                }}
              >
                Submit
              </Button>
              {/* <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              /> */}
            </div>
          )}
        </div>
      </Row>
    </div>
  );
};

const blockInvalidChar = (e) => {
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
};

const StepOne = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);
  useEffect(() => {
    console.log("props.StepOne", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  const validate = () => {
    props.nextStep();
    props.userCallback();
  };

  return (
    <>
      <br /> <br /> <br />
      <div className="col-xl-12 col-lg-12 stppr-bck">
        {/* <h6 className="card-title">Message Type </h6> */}
        <div className="brd-tab-ovrl-res-hegh">
          <form
            onClick={(e) => {
              props.handleChange("selected_message_type", e.target.value);
            }}
          >
            <ul style={{ display: "flex", justifyContent: "space-evenly" }}>
              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={texticon}
                      width="50%"
                      height="60%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "6px 29px" }}>Text</h6>
                    <input
                      style={{ display: "block", margin: "0 auto" }}
                      type="radio"
                      name="test"
                      value="1"
                      checked={
                        props.campaign_creation.selected_message_type == "1"
                          ? true
                          : false
                      }
                    />
                  </label>
                </div>
              </li>

              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={imagefile}
                      width="50%"
                      height="50%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "6px 29px" }}> Image </h6>
                    <input
                      style={{ display: "block", margin: "0 auto" }}
                      type="radio"
                      name="test"
                      value="2"
                      checked={
                        props.campaign_creation.selected_message_type == "2"
                          ? true
                          : false
                      }
                      // style={{ marginLeft: "10px" }}
                    />
                  </label>
                </div>
              </li>

              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={audioalone}
                      width="50%"
                      height="50%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "2px 29px" }}> Audio </h6>
                  </label>
                  <input
                    style={{ display: "block", margin: "0 auto" }}
                    type="radio"
                    name="test"
                    value="3"
                    checked={
                      props.campaign_creation.selected_message_type == "3"
                        ? true
                        : false
                    }
                    // style={{ marginLeft: "10px" }}
                  />
                </div>
              </li>

              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={mediaicon}
                      width="50%"
                      height="50%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "6px 29px" }}> Video</h6>
                    <input
                      style={{ display: "block", margin: "0 auto" }}
                      type="radio"
                      name="test"
                      value="4"
                      checked={
                        props.campaign_creation.selected_message_type == "4"
                          ? true
                          : false
                      }
                      // style={{ marginLeft: "20px" }}
                    />
                  </label>
                </div>
              </li>
              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={audiovideo}
                      width="46%"
                      height="50%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "8px 21px" }}> Location </h6>
                    <input
                      style={{ display: "block", margin: "0 auto" }}
                      type="radio"
                      name="test"
                      value="5"
                      checked={
                        props.campaign_creation.selected_message_type == "5"
                          ? true
                          : false
                      }
                      // style={{ marginLeft: "20px" }}
                    />
                  </label>
                </div>
              </li>
              <li>
                <div className="lbl-stpr-bck">
                  <label>
                    <img
                      src={template}
                      width="47%"
                      height="50%"
                      style={{ margin: "0px 20px" }}
                    />
                    <br />
                    <h6 style={{ margin: "8px 21px" }}> Template</h6>
                    <input
                      style={{ display: "block", margin: "0 auto" }}
                      type="radio"
                      name="test"
                      value="7"
                      checked={
                        props.campaign_creation.selected_message_type == "7"
                          ? true
                          : false
                      }
                      // style={{ marginLeft: "20px" }}
                    />
                  </label>
                </div>
              </li>
            </ul>
          </form>
        </div>
        <br />
        <ActionButtons {...props} nextStep={validate} />
      </div>
    </>
  );
};

const StepTwo = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);

  const [approvalTemp, setApprovalTemp] = useState([]);
  const [templateDeal, setTemplateDeal] = useState([]);

  useEffect(() => {
    console.log("props.StepTwo", props);
    getapprovalTempList();
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  const validate = () => {
    props.nextStep();
    props.userCallback();
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
    ],
  };

  // formats
  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
  ];

  const onChangeFormValue = () => {
    // this.setState({ [key]: value });
  };

  const handleFileChange = (fileData) => {
    if (!fileData || !fileData.size || !fileData.type || !fileData.base64) {
      swal(
        "Error",
        "Invalid file data. Please ensure the file is not corrupted and try again."
      );
      return;
    }
  
    const imageTypes = ["image/jpeg", "image/png", "image/gif"];
    const audioTypes = ["audio/mp3", "audio/ogg", "audio/wav"];
    const videoTypes = ["video/mp4", "video/avi", "video/ogg"];
    const maxFileSize = 50 * 1024 * 1024; // 50MB maximum file size
  
    if (fileData.size > maxFileSize) {
      swal("Oops", "File size exceeds the 50MB limit.");
      return;
    }
  
    const { selected_message_type } = props.campaign_creation;
    let validTypes;
    switch (selected_message_type) {
      case "2":
        validTypes = imageTypes;
        break;
      case "3":
        validTypes = audioTypes;
        break;
      case "4":
        validTypes = videoTypes;
        break;
      default:
        swal("Error", "Unsupported file type for selected message format.");
        return;
    }
  
    if (!validTypes.includes(fileData.type)) {
      swal(
        "Invalid File Type",
        `Only ${validTypes.join(
          ", "
        )} formats are allowed for this type of file.`
      );
      return;
    }
  
    const base64Content = fileData.base64.split(",")[1];
    props.handle_Stepper_file(base64Content, fileData.name);
  };
  

  const getapprovalTempList = async () => {
    let getoutletList = await getApprovalTemplateListMaster();
    let getoutletListValue = getoutletList?.data?.data;

    console.log("outletMasterlist", getoutletListValue);
    setTemplateDeal(getoutletListValue);
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(
        ({
          templateName,
          templateId,
          headerType,
          language,
          headerText,
          headerUrl,
          body,
          footer,
          outletId,
        }) => ({
          label: `${templateName}`,
          value: templateId,
          templateName: templateName,
          templateId: templateId,
          headerType: headerType,
          language: language,
          headerText: headerText,
          headerUrl: headerUrl,
          body: body,
          footer: footer,
          outletId: outletId,
        })
      );
    // console.log("companyoutmaster", companyoutmaster);
    setApprovalTemp(companyoutmaster);
  };

  const templateData = [
    {
      name: "Payment Template",
      header: "Dear User,",
      body: "Order No: FIS0404 , Date: 01/03/2024, Order Type:Non-veg , Amount: ₹400 , Payment mode: , Payment by UPI link: ",
      image: null, // You can provide image URL here if available
    },
    {
      name: "Offer Template",
      header: "Dear User,",
      body: "The Biggest Summer offer is available 🍦  Get up to 25% off 🍨🍦🍧  Use Code: 'ARUNICE25'  Hurry! offer valid till DD MM YYYY",
      image:
        "https://images.pexels.com/photos/459225/pexels-photo-459225.jpeg?cs=srgb&dl=daylight-environment-forest-459225.jpg&fm=jpg",
    },
  ];
  const [state, setState] = useState({});
  const [tempDetails, setTempDetails] = useState({
    templateName: "",
    templateId: "",
    headerType: "",
    language: "",
    headerText: "",
    headerUrl: "",
    body: "",
    footer: "",
    outletId: "",
  });

  const handleChange = (field, value) => {
    let trimmedValue = value;

    // Check if the field is "selected_message_text" and the length of the value is greater than zero
    if (field === "selected_message_text" && value.length > 0) {
      // Trim leading whitespace
      trimmedValue = value.trimStart();
    }

    // Update the state with the new value
    setState((prevState) => ({
      ...prevState,
      campaign_creation: {
        ...prevState.campaign_creation,
        [field]: trimmedValue,
      },
    }));
  };

  const handleTemplate = (data) => {
    console.log("dataobject :>> ", data);

    // let selectedTemplate = approvalTemp.find(
    //   (value, templatedId) => templatedId === data?.templateId
    // );
    // console.log('selectedTemplate :>> ', selectedTemplate);
    setTempDetails({
      templateName: data?.templateName,
      templateId: data?.templateId,
      headerType: data?.headerType,
      language: data?.language,
      headerText: data?.headerText,
      headerUrl: data?.headerUrl,
      body: data?.body,
      footer: data?.footer,
      outletId: data?.outletId,
    });
  };

  return (
    <>
      {/* <h6 className="card-title">
        {props.campaign_creation.selected_message_type != "5"
          ? "Message"
          : "Location"}{" "}
      </h6> */}

      {props.campaign_creation.selected_message_type != "5" &&
        props.campaign_creation.selected_message_type != "7" && (
          <div className="row" style={{ height: "32vh" }}>
            <div className="col-xl-12 col-md-12 col-lg-12">
              <div
                className="input-group mb-3"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="form-group mb-3">
                  <label className="text-label" style={{ display: "flex" }}>
                    Enter Message
                  </label>
                  <textarea
                    value={props.campaign_creation.selected_message_text}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (!value.startsWith(" ") || value.trim() !== "") {
                        props.handleChange("selected_message_text", value);
                      } else {
                        props.handleChange(
                          "selected_message_text",
                          value.trimStart()
                        );
                      }
                    }}
                    style={{ width: "300px", height: "40px" }}
                  ></textarea>
                </div>
              </div>
            </div>
            {(props.campaign_creation.selected_message_type == "2" ||
              props.campaign_creation.selected_message_type == "3" ||
              props.campaign_creation.selected_message_type == "4") && (
              <div
                className="col-xl-12 col-lg-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="input-group mb-3" style={{ width: "27%" }}>
                  <label className="text-label">File Upload</label>
                  <div className="input-group mb-3">
                    <div className="form-file" style={{ border: "0px" }}>
                      <FileBase64 multiple={false} onDone={handleFileChange} />
                    </div>
                  </div>{" "}
                </div>{" "}
              </div>
            )}
          </div>
        )}
      {props.campaign_creation.selected_message_type == "5" && (
        <>
          <div className="row" style={{ height: "32vh" }}>
            <div class="col"></div>
            <div class="col">
              <div className="form-group mb-3">
                <label className="text-label">Latitude </label>
                <input
                  style={{ borderRadius: "0px" }}
                  type="number"
                  step="none"
                  name="firstName"
                  className="form-control"
                  placeholder="Latitude "
                  required
                  value={props.campaign_creation.selected_Latitude}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, ""); // remove non-numeric characters except decimal point
                    props.handleChange("selected_Latitude", value);
                  }}
                />
              </div>
            </div>
            <div class="col">
              <div className="form-group mb-3">
                <label className="text-label">Longitude </label>
                <input
                  style={{ borderRadius: "0px" }}
                  type="number"
                  step="0.01"
                  name="lastName"
                  value={props.campaign_creation.selected_longitude}
                  className="form-control"
                  placeholder="longitude "
                  required
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, ""); // remove non-numeric characters except decimal point
                    props.handleChange("selected_longitude", value);
                  }}
                />
              </div>
            </div>

            <div class="col"></div>
          </div>

          <div
            className="row"
            style={{ marginTop: "-80px", alignItems: "flex-start" }}
          >
            <div
              className="col-12"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="form-group mb-3"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label className="text-label">Address</label>
                <textarea
                  value={props.campaign_creation.selected_address}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (!value.startsWith(" ") || value.trim() !== "") {
                      props.handleChange("selected_address", value);
                      console.log("value value :>> ", value);
                    } else {
                      props.handleChange("selected_address", value.trimStart());
                    }
                  }}
                  style={{ width: "300px", height: "40px" }}
                ></textarea>
              </div>
            </div>
            {/* <div className="col">
    <div className="form-group mb-3">
      <label className="text-label">Name of Owner</label>
      <input
        type="text"
        name="lastName"
        value={props.campaign_creation.selected_address_name}
        className="form-control"
        placeholder="longitude"
        required
        onChange={(e) => {
          props.handleChange("selected_address_name", e.target.value);
        }}
      />
    </div>
  </div> */}
          </div>
        </>
      )}
      {props.campaign_creation.selected_message_type === "7" && (
        <>
          <div className="row" style={{ height: "33vh" }}>
            <div className="col"></div>
            <div className="col">
              <div className="form-group mb-3">
                <label className="text-label">Template List</label>
                <Select
                  options={
                    approvalTemp
                    // props.template_Master_List && props.template_Master_List
                  }
                  search
                  value={props.campaign_creation?.selected_template_name}
                  onChange={(e) => {
                    // handleTemplate(event);
                    props.handleChange("selected_template_name", e);
                    console.log("eeeeeee", e);
                  }}
                />
              </div>
            </div>

            <div className="col">
              <div
                className="form-group mb-0"
                style={{ fontSize: "14px", fontWeight: "900" }}
              >
                Preview
              </div>
              <div
                key={
                  props.campaign_creation?.selected_template_name?.templateId
                }
                className="form-group mb-3 template-card brdct-temp-crd-bck-des"
                style={{ backgroundColor: "whitesmoke" }}
              >
                <h5>
                  {
                    props.campaign_creation?.selected_template_name
                      ?.templateName
                  }
                </h5>
                {props.campaign_creation?.selected_template_name?.headerUrl && (
                  <img
                    src={
                      props.campaign_creation?.selected_template_name?.headerUrl
                    }
                    alt="template image"
                    width="40%"
                    height="60%"
                    style={{
                      marginLeft: "55px",
                      backgroundColor: "whitesmoke",
                    }}
                  />
                )}
                <br />
                <br />
                <p style={{ fontSize: "14px" }}>
                  {props.campaign_creation?.selected_template_name?.body}
                </p>
              </div>
              {/* {campaign_creation?.selected_template_name !== "" &&
                approvalTemp.map((template) => {
                  if (tempDetails?.templateId === template?.templateId) {
                    return (
                      // <div
                      //   key={template.templateName}
                      //   className="form-group mb-3 template-card brdct-temp-crd-bck-des"
                      //   style={{ backgroundColor: "whitesmoke" }}
                      // >
                      //   <h5>{template?.headerText}</h5>
                      //   {template.headerUrl && (
                      //     <img
                      //       src={template.headerUrl}
                      //       alt="template image"
                      //       width="40%"
                      //       height="60%"
                      //       style={{
                      //         marginLeft: "55px",
                      //         backgroundColor: "whitesmoke",
                      //       }}
                      //     />
                      //   )}
                      //   <br />
                      //   <br />
                      //   <p style={{ fontSize: "14px" }}>{template?.body}</p>
                      // </div>
                    );
                  }
                  return null;
                })} */}
            </div>

            <div className="col"></div>
          </div>
        </>
      )}

      <ActionButtons {...props} nextStep={validate} />

      {/* {props.campaign_creation.selected_message_type != "5" &&
        props.campaign_creation.selected_message_type != "7" &&
        props.campaign_creation.selected_message_text != "" && (
          <ActionButtons {...props} nextStep={validate} />
        )}
      {(props.campaign_creation.selected_message_type == "2" ||
        props.campaign_creation.selected_message_type == "3" ||
        props.campaign_creation.selected_message_type == "4") &&
        props.campaign_creation.selected_message_file != "" &&
        props.campaign_creation.selected_message_text != "" && (
          <ActionButtons {...props} nextStep={validate} />
        )}

      {props.campaign_creation.selected_message_type == "5" &&
        props.campaign_creation.selected_Latitude != "" &&
        props.campaign_creation.selected_longitude != "" && (
          <ActionButtons {...props} nextStep={validate} />
        )} */}
    </>
  );
};
const StepThree = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);
  useEffect(() => {
    console.log("props.StepThree", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  const validate = () => {
    props.nextStep();
    props.userCallback();
  };

  return (
    <>
      <div className="col-xl-12 col-lg-6">
        <h4 className="card-title"> Schedule Type</h4>
        <div className="card-body">
          <div className="basic-form">
            <form
              onClick={(e) => {
                props.handleChange("message_schedule_type", e.target.value);
              }}
            >
              <div className="form-group mb-0">
                <ul style={{ display: "flex" }}>
                  <li style={{ marginLeft: "23%", width: "20%" }}>
                    <label className="radio-inline me-3">
                      <input
                        type="radio"
                        name="test"
                        value="individual"
                        checked={
                          props.campaign_creation.message_schedule_type ==
                          "individual"
                            ? true
                            : false
                        }
                      />{" "}
                      <h3 style={{ margin: "5px 24px" }}>Immediate</h3>
                    </label>
                  </li>

                  <li style={{ width: "20%" }}>
                    <label className="radio-inline me-3">
                      <input
                        type="radio"
                        name="test"
                        value="multiple"
                        checked={
                          props.campaign_creation.message_schedule_type ==
                          "multiple"
                            ? true
                            : false
                        }
                      />
                      <h3 style={{ margin: "5px 24px" }}>Schedule</h3>
                    </label>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
      <br />
      <ActionButtons {...props} nextStep={validate} />
    </>
  );
};
const StepFour = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);
  useEffect(() => {
    console.log("props.StepOne", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  const handleLastStep = () => {
    props.lastStep();
    props.completeCallback();
  };

  // const handleRadioClick = () => {
  //   setShowInput(!showInput);
  //   setMultiShowInput(false);
  // };

  // const handlemultiClick = () => {
  //   setMultiShowInput(!multishowInput);
  //   setShowInput(false);
  // };
  // const handleInputChange = (e) => {
  //   setUserInput(e.target.value);
  // };

  const columns = [
    {
      name: "Order_No",
      label: "Order No",
      // options: {
      //   filter: false,
      //   customFilterListOptions: { render: (v) => `Retailer Name: ${v}` },
      //   fixedHeader: false,
      //   responsive: "stacked",
      //   filterType: "textField",
      // },
    },
    {
      name: "Order_by_number",
      label: "Order",
      // options: {
      //   filter: false,
      //   customFilterListOptions: { render: (v) => `Retailer Name: ${v}` },
      //   fixedHeader: false,
      //   responsive: "stacked",
      //   filterType: "textField",
      // },
    },
    {
      name: "Order_by",
      label: "User",
      // options: {
      //   filter: false,
      //   customFilterListOptions: { render: (v) => `Retailer Name: ${v}` },
      //   fixedHeader: false,
      //   responsive: "stacked",
      //   filterType: "textField",
      // },
    },
    {
      name: "Order_amount",
      label: "Amount",
      // options: {
      //   filter: false,
      //   customFilterListOptions: { render: (v) => `Retailer Name: ${v}` },
      //   fixedHeader: false,
      //   responsive: "stacked",
      //   filterType: "textField",
      // },
    },

    {
      name: "Actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          // console.log("tableMeta", tableMeta?.rowData[4]);
          return (
            <div className="list-action">
              <input
                type="checkbox"
                id="checkbox"
                // checked={tableMeta?.rowData[4]}
                // style={{ color: tableMeta?.rowData[4] ? "red" : "" }}
                onClick={(e) => {
                  // console.log("tableMeta", tableMeta);
                  // console.log("e.target.value", e.target.value);
                  // console.log("e.target.checked", e);
                  // this.checkuncheckitems(tableMeta, e.target.checked);
                }}
              />
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    search: false,
    sort: false,
    fixedHeader: true,
    tableBodyHeight: "425px",
    resizableColumns: false,
    draggableColumns: {
      enabled: true,
    },
    // setFilterChipProps: (colIndex, colName, data) => {
    //   return {
    //     color: "primary",
    //     variant: "outlined",
    //     className: "testClass123",
    //   };
    // },
    // textLabels: {
    //   body: {
    //     noMatch: labelmessage,
    //   },
    // },
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    // currentPage: currentPage,
    pagination: true,
    serverSide: true,
    // rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    download: false,
    print: false,
  };

  const themeTablevalues = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#3A72B7 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "18px",
        },
      },
    },
  });

  return (
    <>
      <div className="col-xl-12 col-lg-6 demo-heighr">
        {/* <h4 className="card-title">User Type </h4> */}
        {props.campaign_creation.selected_message_type == "6" ? (
          <>
            {/* <div className="row">
              <div class="col">
                <div className="form-group mb-3">
                  <label className="text-label">Payment Details </label>
                  <Select
                    options={props.order_Master_List && props.order_Master_List}
                    search
                    // value={{ label: "Payment Template", value: "Payment Template" }}
                    // defaultValue={props.order_Master_List && props.order_Master_List[0].value}
                    // name="stateCode"
                    // <!-- onChange={(e) => {
                    //   swal("Unavailable")
                    //   return false;
                    //   //   props.onchange_setSelected_details_order_Master(e);
                    // }} -->
                  />
                </div>
              </div>
              <div class="col"></div>
              <div class="col"></div>
            </div> */}

            <MuiThemeProvider theme={themeTablevalues}>
              <MUIDataTable
                title={"Order List"}
                data={props.order_Master_List && props.order_Master_List}
                columns={columns}
                options={options}
                columOrder={columns}
              />
            </MuiThemeProvider>
          </>
        ) : (
          <div className="basic-form stppr-bck">
            <form
              onChange={(e) => {
                props.handleChange("message_recipient_type", e.target.value);
              }}
            >
              <div className="form-group mb-0">
                <ul style={{ display: "flex", justifyContent: "center" }}>
                  <li>
                    <div className="lbl-stpr-bck">
                      <label className="radio-inline me-3">
                        <img
                          src={individual}
                          alt="individual image"
                          width="50%"
                          height="60%"
                          style={{ margin: "1px 23px" }}
                        />
                        <h5 style={{ margin: "5px 12px" }}>Individual</h5>{" "}
                        <input
                          style={{ display: "block", margin: "0 auto" }}
                          type="radio"
                          name="test"
                          value="1"
                          checked={
                            props.campaign_creation.message_recipient_type ==
                            "1"
                          }
                        />{" "}
                      </label>
                    </div>
                  </li>

                  <li style={{ marginLeft: "20px" }}>
                    <div className="lbl-stpr-bck">
                      <label className="radio-inline me-3">
                        <img
                          src={multiple}
                          alt="multiple image"
                          width="50%"
                          height="60%"
                          style={{ margin: "0px 19px" }}
                        />

                        <h5 style={{ margin: "5px 20px" }}>Multiple</h5>
                        <input
                          style={{ display: "block", margin: "0 auto" }}
                          type="radio"
                          name="test"
                          value="2"
                          checked={
                            props.campaign_creation.message_recipient_type ==
                            "2"
                          }
                        />
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </form>
            <br /> <br />
            {props.campaign_creation.message_recipient_type == "1" && (
              <div className="row">
                <div
                  className="col-12 cmpg-src-inp"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <label>
                    Enter User Number
                    <input
                      className="form-file-input form-control"
                      type="number"
                      required
                      value={props.campaign_creation.message_recipient_no}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        const invalidChars = ["-", "+", "e", ","];
                        if (invalidChars.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, "");
                        if (value === "" || /^[6-9]\d{0,9}$/.test(value)) {
                          props.handleChange("message_recipient_no", value);
                        }
                      }}
                    />
                  </label>
                </div>
              </div>
            )}
            {props.campaign_creation.message_recipient_type == "2" && (
              <div className="row ">
                <div
                  className=" col-12 basic-form form_file_input"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <form action="#">
                    <div className="cmp-src-fil-up-in">
                      <div className="form-file">
                        <label>
                          File Upload
                          <input
                            style={{ marginLeft: "7px" }}
                            type="file"
                            accept=".csv, .xls"
                            onChange={(e) => {
                              props.handleChange(
                                "message_recipient_file",
                                e.target.value
                              );
                            }}
                            // className="form-file-input form-control"
                          />
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
            <div>
              {/* <Link to={`/Campaign`}> */}
              {/* <Button
              variant="contained"
              style={{ marginLeft: "85%" }}
              size="medium"
              onClick={() => {
                
                props.submit_campaign_creation();
              }}
            >
              Submit
            </Button> */}
              {/* </Link>{" "} */}
            </div>
          </div>
        )}
      </div>
      <br />
      <ActionButtons {...props} lastStep={handleLastStep} />
    </>
  );
};

const Campaign_Service = () => {
  const [campaign_creation, setCampaign_creation] = useState({
    selected_message_type: "1",
    selected_message_text: "",
    selected_message_file: "",
    selected_message_file_name: "",
    selected_message_template_id: "",
    message_schedule_type: "individual",
    message_recipient_type: "1",
    message_recipient_no: "",
    message_recipient_file: "",
    selected_Latitude: "",
    selected_longitude: "",
    selected_address: "",
    selected_address_name: "",
    selected_template_name: {},
  });
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const [template_Master_List, setTemplate_Master_List] = useState([
    { label: "Payment Template", value: "Payment Template" },
    { label: "Offer Template", value: "Offer Template" },
  ]);

  const [order_Master_List, setOrder_Master_List] = useState([
    {
      label: "10000125",
      value: "10000125",
      Order_No: "10000125",
      Order_by_number: "919087654321",
      Order_by: "Adhithyan",
      Order_date: "20-09-2023",
      Order_Type: "Breakfast",
      Order_amount: "200.00",
      Order_payment_mode: "G-Pay",
      Order_QRCode: "http://ucp.clsslabs.com/OMS/payment?orderId=10000125",
      Order_UPI_link: "http://ucp.clsslabs.com/OMS/payment?orderId=10000125",
    },
    {
      label: "10000126",
      value: "10000126",
      Order_No: "10000126",
      Order_by_number: "919087654321",
      Order_by: "vijay",
      Order_date: "20-09-2023",
      Order_Type: "Dinner",
      Order_amount: "250.00",
      Order_payment_mode: "G-Pay",
      Order_QRCode: "http://ucp.clsslabs.com/OMS/payment?orderId=10000126",
      Order_UPI_link: "http://ucp.clsslabs.com/OMS/payment?orderId=10000126",
    },
    {
      label: "10000127",
      value: "10000127",
      Order_No: "10000127",
      Order_by_number: "919087654321",
      Order_by: "muthu",
      Order_date: "20-09-2023",
      Order_Type: "Dinner",
      Order_amount: "150.00",
      Order_payment_mode: "G-Pay",
      Order_QRCode: "http://ucp.clsslabs.com/OMS/payment?orderId=10000127",
      Order_UPI_link: "http://ucp.clsslabs.com/OMS/payment?orderId=10000127",
    },
    {
      label: "10000128",
      value: "10000128",
      Order_No: "10000128",
      Order_by_number: "919087654321",
      Order_by: "raj sekar",
      Order_date: "20-09-2023",
      Order_Type: "Lunch",
      Order_amount: "150.00",
      Order_payment_mode: "G-Pay",
      Order_QRCode: "http://ucp.clsslabs.com/OMS/payment?orderId=10000128",
      Order_UPI_link: "http://ucp.clsslabs.com/OMS/payment?orderId=10000128",
    },
  ]);
  const [selected_details_order_Master, setSelected_details_order_Master] =
    useState({});
  const [send_order_template, setSend_order_template] = useState();

  useEffect(() => {}, [campaign_creation]);

  const handleReactSelectChange = (key, value) => {
    if (key === "message_recipient_no" && value && value.length > 10) {
      return false;
    }
    console.log("Campaign_Service key,", key, value);
    const newFormData = { ...campaign_creation };
    newFormData[key] = value;
    console.log("newFormData key vjvj", newFormData);
    setCampaign_creation(newFormData);
  };

  const handle_Stepper_file_Change = (value0, value1) => {
    const newFormData = { ...campaign_creation };
    newFormData["selected_message_file"] = value0;
    newFormData["selected_message_file_name"] = value1;
    setCampaign_creation(newFormData);
  };

  const submit_campaign_creation = async () => {
    console.log("submit_campaign_creation sdf", campaign_creation);
    // console.log(
    //   "campaign_creation.selected_message_type sdf",
    //   campaign_creation.selected_message_type
    // );
    let customerList;
    let url_dynamic;
    let data_dynamic;

    switch (campaign_creation.selected_message_type) {
      case "1":
        data_dynamic = {
          messaging_product: "whatsapp",
          recipient_type: campaign_creation.message_schedule_type,
          to: `${91}${campaign_creation.message_recipient_no}`,
          type: "text",
          text: {
            body: campaign_creation.selected_message_text,
          },
        };
        url_dynamic = "sendMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "2":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: campaign_creation.selected_message_file_name,
          data: {
            messaging_product: "whatsapp",
            recipient_type:
              "individual" || campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "image",
            image: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendImageMessage";
        // console.log(data_dynamic, "data_dynamic");
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "3":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: campaign_creation.selected_message_file_name,
          data: {
            messaging_product: "whatsapp",
            recipient_type:
              "individual" || campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "audio",
            audio: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendAudioMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "4":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: campaign_creation.selected_message_file_name,
          data: {
            messaging_product: "whatsapp",
            recipient_type:
              "individual" || campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "video",
            video: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendVideoMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "5":
        data_dynamic = {
          messaging_product: "whatsapp",
          recipient_type:
            "individual" || campaign_creation.message_schedule_type,
          to: `${91}${campaign_creation.message_recipient_no}`,
          type: "location",
          location: {
            latitude: campaign_creation.selected_Latitude,
            longitude: campaign_creation.selected_longitude,
            address: campaign_creation.selected_address,
            name: campaign_creation.selected_address_name,
          },
        };
        url_dynamic = "sendLocationMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "7":
        let data_dynamic = {
          messaging_product: "whatsapp",
          recipient_type:
            "individual" || campaign_creation.message_schedule_type,
          to: `${91}${campaign_creation.message_recipient_no}`,
          type: "template",
          template: {
            name: campaign_creation?.selected_template_name?.templateName,
            language: {
              code: "en_us",
            },
            components: [
              {
                type: "header",
                parameters: [
                  {
                    type: campaign_creation?.selected_template_name?.type,
                    image: {
                      link: campaign_creation?.selected_template_name
                        ?.headerUrl,
                    },
                  },
                ],
              },
              {
                type: "body",
                parameters: [
                  {
                    type: "text",
                    text: campaign_creation?.selected_template_name?.body,
                  },
                  {
                    type: "date_time",
                    date_time: {
                      fallback_value: "February 00, 2024",
                      day_of_week: 5,
                      year: 2024,
                      month: 2,
                      day_of_month: 25,
                      hour: 15,
                      minute: 33,
                      calendar: "GREGORIAN",
                    },
                  },
                ],
              },
            ],
          },
        };
        // data_dynamic =
        //   campaign_creation.selected_template_name.value == "Offer Template"
        //     ? offer_template
        //     : send_order_template;
        url_dynamic = "sendTemplateInteractiveMessage";

        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      default:
        return alert("something went wrong");
    }

    console.log("customerList customerList", customerList);
    if (customerList?.status === 200) {
      // toast.success("successful", {
      //   position: "top-right",
      //   autoClose: 3000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      swal("Success!", "success", "success");
      setCampaign_creation({
        selected_message_type: "1",
        selected_message_text: "",
        selected_message_file: "",
        selected_message_file_name: "",
        selected_message_template_id: "",
        message_schedule_type: "individual",
        message_recipient_type: "1",
        message_recipient_no: "",
        message_recipient_file: "",
        selected_Latitude: "",
        selected_longitude: "",
        selected_address: "",
        selected_address_name: "",
      });
      // history.push("/Campaign");
      window.location.replace("#/Campaign");
      // window.location.reload(true);
    } else {
      // toast.error(`${customerList?.data?.error?.message}`, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      swal(`${customerList?.data?.error?.message}`, "");
    }

    // const newFormData = {...campaign_creation};
    // newFormData[key] = value;
    // setCampaign_creation(newFormData);
  };

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignUser = (val) => {
    // console.log("parent receive user callback");
    // console.log(val);
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    // console.log("step change");
    console.log(e);
    setActiveStep(e.activeStep - 1);
  };

  const onchange_setSelected_details_order_Master = (e) => {
    // console.log(e);
    setSelected_details_order_Master(e);
    setSend_order_template({
      messaging_product: "whatsapp",
      recipient_type: "individual",
      recipient_to: e.Order_by_number,
      type: "template",
      template: {
        name: "order_confirmation",
        language: {
          code: "en_us",
        },
      },
      components: [
        {
          type: "body",
          parameters: [
            {
              type: "text",
              text: e.Order_by,
            },
            {
              type: "text",
              text: e?.value,
            },
            {
              type: "date_time",
              date_time: {
                fallback_value: e?.Order_date,
              },
            },
            {
              type: "text",
              text: e?.Order_Type,
            },
            {
              type: "currency",
              currency: {
                fallback_value: `₹ ${e?.Order_amount}`,
                code: "Rupees",
                amount_1000: e?.Order_amount,
              },
            },
            {
              type: "text",
              text: e?.Order_payment_mode,
            },
            {
              type: "text",
              text: e?.Order_QRCode,
            },
            {
              type: "text",
              text: e?.Order_UPI_link,
            },
          ],
        },
      ],
    });
  };

  const handleComplete = () => {
    // alert("You r done. TQ");
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12 col-xxl-12" style={{ height: "80vh" }}>
          <div className="card brdcst-crd">
            <div className="card-header ovrl-crd-hd">
              <h4 className="card-title">Broadcast </h4>

              <Link to={`/Campaign`}>
                <Button
                  variant="contained"
                  // style={{ marginLeft: "50%" }}
                  size="medium"
                >
                  Broadcast List
                </Button>
              </Link>
            </div>

            <div className="card-body">
              <Stepper activeStep={activeStep}>
                <Step label="Message Type" />
                <Step label="Message" />
                <Step label="Recipient" />
              </Stepper>
              {/* NOTE: IMPORTANT !! StepWizard must contains at least 2 children components, else got error */}
              <StepWizard
                instance={assignStepWizard}
                onStepChange={handleStepChange}
              >
                <StepOne
                  handleChange={(key, value) => {
                    handleReactSelectChange(key, value);
                  }}
                  campaign_creation={campaign_creation}
                  userCallback={assignUser}
                />
                <StepTwo
                  handleChange={(key, value) => {
                    console.log("key :>> ", key);
                    console.log("value :>> ", value);
                    handleReactSelectChange(key, value);
                  }}
                  handle_Stepper_file={(key, value) => {
                    handle_Stepper_file_Change(key, value);
                  }}
                  campaign_creation={campaign_creation}
                  userCallback={assignUser}
                  template_Master_List={template_Master_List}
                  selected_details_order_Master={selected_details_order_Master}
                  onchange_setSelected_details_order_Master={(e) => {
                    onchange_setSelected_details_order_Master(e);
                  }}
                />
                <StepFour
                  handleChange={(key, value) => {
                    handleReactSelectChange(key, value);
                  }}
                  campaign_creation={campaign_creation}
                  submit_campaign_creation={() => {
                    submit_campaign_creation();
                  }}
                  userCallback={assignUser}
                  completeCallback={handleComplete}
                  order_Master_List={order_Master_List}
                  selected_details_order_Master={selected_details_order_Master}
                  onchange_setSelected_details_order_Master={(e) => {
                    onchange_setSelected_details_order_Master(e);
                  }}
                />
                {/* <One userCallback={assignUser} /> */}
                {/* <Two user={user} userCallback={assignUser} />
                  <Three user={user} completeCallback={handleComplete} /> */}
              </StepWizard>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default Campaign_Service;
